shadow$provide[79] = function(global,require,module,exports) {
module.exports=(pt_ts);
};